export default __webpack_public_path__ + "static/screenshot1-ddc6f97fa90bd487d9e5f1edcbf02f14.jpg";